import React, { useState, useEffect } from 'react'
import { 
  Box, 
  VStack, 
  Text, 
  Heading, 
  Link,
  IconButton,
  useColorModeValue
} from '@chakra-ui/react'
import { FaArrowLeft } from 'react-icons/fa'
import { useAuthContext } from '../../contexts/AuthContext'
import { useLocation, useNavigate } from 'react-router-dom'
import { LoginForm } from './LoginForm'
import { RegisterForm } from './RegisterForm'

interface AuthPageProps {
  onSuccess?: () => void
  defaultMode?: 'login' | 'register'
}

export const AuthPage: React.FC<AuthPageProps> = ({ onSuccess, defaultMode = 'login' }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [mode, setMode] = useState<'login' | 'register'>(defaultMode)
  
  // Check URL parameters for mode
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const urlMode = params.get('mode')
    if (urlMode === 'register') {
      setMode('register')
    } else if (urlMode === 'login') {
      setMode('login')
    }
  }, [location.search])
  
  const bgColor = useColorModeValue('#09090b', '#09090b')
  const textColor = useColorModeValue('white', 'white')

  return (
    <Box minH="100vh" bg={bgColor} display="flex" alignItems="center" justifyContent="center" p={4} position="relative">
      {/* Back Arrow - Only show on login page */}
      {mode === 'login' && (
        <Box position="absolute" top={4} left="50%" transform="translateX(-50%)" zIndex={9999}>
          <IconButton
            aria-label="Back to landing page"
            icon={<FaArrowLeft />}
            onClick={() => navigate('/')}
            variant="ghost"
            color="white"
            _hover={{ bg: 'rgba(255, 255, 255, 0.1)' }}
            size="lg"
          />
        </Box>
      )}
      <Box w="full" maxW="md">
        {/* Logo/Brand - Hidden on both pages */}
        {/* 
        <VStack spacing={8} textAlign="center" mb={8}>
          <Heading size="2xl" color={textColor}>
            AI Scoring App
          </Heading>
          <Text color="gray.300">
            Sign in to your account or create a new one
          </Text>
        </VStack>
        */}

        {/* Auth Forms */}
        {mode === 'login' ? (
          <LoginForm 
            onSuccess={onSuccess}
            onSwitchToRegister={() => setMode('register')}
          />
        ) : (
          <RegisterForm 
            onSuccess={onSuccess}
            onSwitchToLogin={() => setMode('login')}
          />
        )}

        {/* Footer */}
        <Box textAlign="center" mt={8}>
          <Text color="gray.400" fontSize="sm">
            By continuing, you agree to our{' '}
            <Link color="blue.400" _hover={{ color: 'blue.300' }} onClick={() => navigate('/terms')} cursor="pointer">
              Terms of Service
            </Link>
            {' '}and{' '}
            <Link color="blue.400" _hover={{ color: 'blue.300' }} onClick={() => navigate('/terms')} cursor="pointer">
              Privacy Policy
            </Link>
          </Text>
        </Box>
      </Box>
    </Box>
  )
} 